<template>
    <div id="questionDetail">
        <h4 :class="[questionInfo.disposeState == 1 ? 'unprocessed' : 'processed']">{{ questionInfo.disposeState == 1 ? '待处理' : '已处理' }}</h4>
        <div class="info">            
            <div class="line">
                <label>工单号：</label>
                <div><span>{{ questionInfo.id }}</span></div>
            </div>
            <div class="line" v-if="isLine">
                <label>号码：</label>
                <div><span>{{ recordLoginText }}</span></div>
            </div>
            <div class="line" v-else>
                <label>号码：</label>
                <div><span>{{ lineComplaintText }}</span></div>
            </div>
            <div class="line">
                <label>问题描述：</label>
                <div class="moreInfo">{{ questionInfo.problemContent }}</div>
            </div>        
            <template v-if="questionInfo.disposeState == 2">
                <div class="line">
                    <label>处理方案：</label>
                    <div class="moreInfo">{{ questionInfo.remark }}</div>
                </div>
                <div class="line">
                    <label>处理时间：</label>
                    <div>{{ questionInfo.disposeTime }}</div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import {wxRequest} from '@/api/user'
export default {
    data(){
        return {
            questionInfo: {
                disposeState: '',
                id: '',
                iccid: '',
                disposeTime: '',
                problemContent: '',
                remark: ''
            },
            recordLoginText: localStorage.getItem('recordLoginText'),
            isLine: sessionStorage.getItem('isLine'), //判断是否登录进来还是链接进来
            lineComplaintText: sessionStorage.getItem('lineComplaintText')
        }
    },
    methods: {

    },
    created(){
        var id = this.$route.query.id;
        wxRequest("userProblem/problemInfo", {id}, "post").then(res => {
            if(res.data.code == 200){
                for(var key in this.questionInfo){
                    this.questionInfo[key] = res.data.data[key];
                }
            }
        })
    }
    
}
</script>
<style lang="less">
#questionDetail {
    h4 {
        color: #fff;
        line-height: 36px;
        text-align: center;
        &.processed {
            background: #0c931b;
        }
        &.unprocessed {
            background: #ff362c;
        }
    }
    .info {
        padding: 0 4%; 
    }

}
</style>
